module.exports = __webpack_public_path__ + "img/upload_over.20b04c3b.png";